import { useCallback } from 'react';
import { t } from 'i18next';
import { useDispatch } from 'react-redux';

import { TYPES, useShowModal } from '../../../actions/modal';
import {
    cancelDeleteServiceData,
    cancelOperation,
    deleteServiceData,
    endOperation,
    singleOperation,
    startOperation,
} from '../../../actions/airportServices';
import { useAnchorEl } from '../../hooks/useAnchorEl';

export const useAirportServiceListItem = (legId, service) => {
    const showModal = useShowModal();
    const dispatch = useDispatch();
    const [anchorEl, handleOpenMenu, handleClose] = useAnchorEl();

    const handleClick = useCallback(() => {
        showModal(TYPES.SERVICE, {
            legId,
            service,
            title: t('modal.editService'),
        });
        handleClose();
    }, [legId, service]);

    const handleStartClick = useCallback(() => {
        dispatch(startOperation(legId, service.id));
        handleClose();
    }, [legId, service.id]);

    const handleSingleClick = useCallback(() => {
        dispatch(singleOperation(legId, service.id));
        handleClose();
    }, [legId, service.id]);

    const handleEndClick = useCallback(() => {
        dispatch(endOperation(legId, service.id));
        handleClose();
    }, [legId, service.id]);

    const handleCancelClick = useCallback(() => {
        dispatch(cancelOperation(legId, service.id));
        handleClose();
    }, [legId, service.id]);

    const handleDelete = useCallback(() => {
        dispatch(deleteServiceData(legId, service.id));
        handleClose();
    }, [legId, service.id]);

    const handleCancelDelete = useCallback(() => {
        dispatch(cancelDeleteServiceData(legId, service.id));
        handleClose();
    }, [legId, service.id]);

    return {
        handleClick,
        handleStartClick,
        handleSingleClick,
        handleEndClick,
        handleCancelClick,
        handleDelete,
        handleCancelDelete,
        anchorEl,
        handleOpenMenu,
        handleClose,
    };
};
